(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-hero]');
    if (!root) return;

    var track = root.querySelector('[data-hero-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
    var counter = root.querySelector('[data-hero-counter]');
    var prev = root.querySelector('[data-hero-prev]');
    var next = root.querySelector('[data-hero-next]');
    if (slides.length === 0) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = 0;

    function goTo(index) {
      index = Math.max(0, Math.min(index, slides.length - 1));
      var slide = slides[index];
      track.scrollTo({
        left: slide.offsetLeft - (track.clientWidth - slide.clientWidth) / 2,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    }

    function setActive(index) {
      current = index;
      dots.forEach(function (dot, i) {
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (counter) counter.textContent = (index + 1) + ' / ' + slides.length;
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
      slides.forEach(function (slide, i) {
        var video = slide.querySelector('[data-hero-video]');
        if (!video) return;
        if (i === index && wantsToPlay(video)) start(video);
        else video.pause();
      });
    }

    // A person's choice wins over the automatic behaviour, for as long as the page is open.
    function wantsToPlay(video) {
      if (video.dataset.choice) return video.dataset.choice === 'play';
      return !reduceMotion;
    }

    // A refused play leaves the video paused and the button offering Play.
    function start(video) {
      var playback = video.play();
      if (playback && playback.catch) playback.catch(function () {});
    }

    slides.forEach(function (slide) {
      var video = slide.querySelector('[data-hero-video]');
      var toggle = slide.querySelector('[data-hero-video-toggle]');
      if (!video || !toggle) return;
      function show() {
        var playing = !video.paused;
        toggle.setAttribute('data-playing', playing ? 'true' : 'false');
        toggle.setAttribute('aria-label', playing ? toggle.dataset.labelPause : toggle.dataset.labelPlay);
      }
      video.addEventListener('play', show);
      video.addEventListener('pause', show);
      toggle.addEventListener('click', function () {
        if (video.paused) {
          video.dataset.choice = 'play';
          start(video);
        } else {
          video.dataset.choice = 'pause';
          video.pause();
        }
      });
      toggle.hidden = false;
      show();
    });

    if (prev) {
      prev.addEventListener('click', function () { goTo(current - 1); });
    }
    if (next) {
      next.addEventListener('click', function () { goTo(current + 1); });
    }
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-index'), 10));
      });
    });

    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') { event.preventDefault(); goTo(current + 1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(current - 1); }
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
          setActive(slides.indexOf(entry.target));
        }
      });
    }, { root: track, threshold: [0.6] });
    slides.forEach(function (slide) { observer.observe(slide); });

    setActive(0);
  })();

  } catch(e) { console.error(e); }
})();
})();
